const _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.default = void 0;

const _react = _interopRequireDefault(require('react'));

const _createSvgIcon = _interopRequireDefault(require('./utils/createSvgIcon'));

const _default = (0, _createSvgIcon.default)(
  _react.default.createElement('path', {
    d: 'M8 0a7.99 7.99 0 0 0-8 8c0 4.427 3.573 8 8 8s8-3.573 8-8-3.573-8-8-8zm0 13.867A5.85 5.85 0 0 1 2.133 8 5.85 5.85 0 0 1 8 2.133 5.85 5.85 0 0 1 13.867 8 5.85 5.85 0 0 1 8 13.867zm3.627-7.84c0 .906-.747 1.653-1.654 1.653A1.662 1.662 0 0 1 8.32 6.027c0-.907.747-1.654 1.653-1.654.907 0 1.654.747 1.654 1.654zm0 3.946c0 .907-.747 1.654-1.654 1.654A1.662 1.662 0 0 1 8.32 9.973c0-.906.747-1.653 1.653-1.653.907 0 1.654.747 1.654 1.653zm-3.947 0c0 .907-.747 1.654-1.653 1.654a1.662 1.662 0 0 1-1.654-1.654c0-.906.747-1.653 1.654-1.653.906 0 1.653.747 1.653 1.653zm0-3.946c0 .906-.747 1.653-1.653 1.653a1.662 1.662 0 0 1-1.654-1.653c0-.907.747-1.654 1.654-1.654.906 0 1.653.747 1.653 1.654z',
  }),
  'Twilio'
);

exports.default = _default;
